var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M469.33,286.637c-21.333,0-21.333-19.506-42.667-19.506c-21.333,0-21.333,19.506-42.665,19.506 s-21.333-19.506-42.665-19.506c-21.333,0-21.333,19.506-42.667,19.506s-21.335-19.506-42.67-19.506 c-21.333,0-21.333,19.506-42.665,19.506c-21.33,0-21.33-19.506-42.663-19.506c-21.335,0-21.335,19.506-42.67,19.506 s-21.335-19.506-42.67-19.506c-21.33,0-21.33,19.506-42.663,19.506c-21.218,0-21.341-19.291-42.332-19.497 c0.591,11.709,1.989,23.206,4.103,34.449c17.004,2.497,18.493,19.18,38.231,19.18c21.333,0,21.333-19.504,42.663-19.504 c21.335,0,21.335,19.504,42.67,19.504s21.335-19.504,42.67-19.504c21.333,0,21.333,19.504,42.663,19.504 c21.333,0,21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504 c21.333,0,21.333,19.504,42.665,19.504c21.333,0,21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.667,19.504 c19.739,0,21.228-16.682,38.233-19.18c2.115-11.244,3.511-22.739,4.105-34.449C490.674,267.347,490.549,286.637,469.33,286.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M426.663,333.913c-21.333,0-21.333,19.506-42.665,19.506s-21.333-19.506-42.665-19.506 c-21.333,0-21.333,19.506-42.667,19.506c-21.335,0-21.335-19.506-42.67-19.506c-21.333,0-21.333,19.506-42.665,19.506 c-21.33,0-21.33-19.506-42.663-19.506c-21.335,0-21.335,19.506-42.67,19.506s-21.335-19.506-42.67-19.506 c-21.33,0-21.33,19.506-42.663,19.506c-15.715,0-19.864-10.578-29.487-16.15c5.828,17.419,13.483,33.998,22.728,49.522 c2.002,0.483,4.228,0.761,6.758,0.761c21.333,0,21.333-19.504,42.663-19.504c21.335,0,21.335,19.504,42.67,19.504 s21.335-19.504,42.67-19.504c21.333,0,21.333,19.504,42.663,19.504c21.333,0,21.333-19.504,42.665-19.504 c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504c21.333,0,21.333,19.504,42.665,19.504 s21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.667,19.504c2.532,0,4.76-0.278,6.763-0.762 c9.246-15.523,16.9-32.102,22.727-49.52c-9.623,5.572-13.773,16.15-29.49,16.15C447.998,353.419,447.998,333.913,426.663,333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M506.044,200.941c-15.594,3.237-17.582,18.913-36.714,18.913c-21.333,0-21.333-19.506-42.667-19.506 c-21.333,0-21.333,19.506-42.665,19.506s-21.333-19.506-42.665-19.506c-21.333,0-21.333,19.506-42.667,19.506 s-21.335-19.506-42.67-19.506c-11.527,0-16.827,5.694-22.628,10.93v34.133c5.801-5.235,11.1-10.928,22.628-10.928 c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504c21.333,0,21.333,19.504,42.665,19.504 s21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.667,19.504c19.739,0,21.228-16.682,38.233-19.18 c1.09,0,2.308-0.011,3.555-0.026C510.173,223.268,508.463,211.972,506.044,200.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M487.344,146.274c-4.421,3.713-9.531,6.797-18.013,6.797c-21.333,0-21.333-19.506-42.667-19.506 c-21.333,0-21.333,19.506-42.665,19.506s-21.333-19.506-42.665-19.506c-21.333,0-21.333,19.506-42.667,19.506 s-21.335-19.506-42.67-19.506c-11.527,0-16.827,5.694-22.628,10.93v34.133c5.801-5.235,11.1-10.928,22.628-10.928 c21.335,0,21.335,19.504,42.67,19.504C320,187.204,320,167.7,341.333,167.7c21.333,0,21.333,19.504,42.665,19.504 S405.33,167.7,426.663,167.7c21.335,0,21.335,19.504,42.667,19.504c15.137,0,19.546-9.805,28.446-15.507 C494.743,163,491.26,154.515,487.344,146.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M428.485,66.835c-0.592-0.032-1.195-0.052-1.822-0.052c-21.333,0-21.333,19.506-42.665,19.506 c-21.333,0-21.333-19.506-42.665-19.506C320,66.783,320,86.289,298.665,86.289c-21.335,0-21.335-19.506-42.67-19.506 c-11.527,0-16.827,5.694-22.628,10.93v34.133c5.801-5.235,11.1-10.928,22.628-10.928c21.335,0,21.335,19.504,42.67,19.504 c21.335,0,21.335-19.504,42.667-19.504c21.333,0,21.333,19.504,42.665,19.504s21.333-19.504,42.665-19.504 c21.335,0,21.335,19.504,42.667,19.504c1.314,0,2.541-0.078,3.703-0.217C460.641,100.441,445.637,82.484,428.485,66.835z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "255.996,0 255.992,0 255.997,0  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M321.432,8.454c-5.856,5.268-11.148,11.054-22.767,11.054c-21.335,0-21.335-19.504-42.669-19.506 h-0.004C244.96,0.003,239.634,5.22,234.11,10.259v34.134c5.523-5.039,10.851-10.257,21.886-10.257 c21.335,0,21.335,19.504,42.67,19.504C320,53.64,320,34.136,341.333,34.136c21.333,0,21.333,19.504,42.665,19.504 c8.951,0,14.143-3.436,18.735-7.422C378.397,29.163,350.959,16.237,321.432,8.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M298.665,486.984c-21.335,0-21.335-19.506-42.67-19.506c-21.333,0-21.333,19.506-42.665,19.506 c-21.33,0-21.33-19.506-42.663-19.506c-16.341,0-20.174,11.434-30.654,16.792c28.9,14.714,60.967,24.093,94.907,26.86 c5.249-4.796,10.581-9.518,21.075-9.518c10.497,0,15.829,4.722,21.079,9.519c33.941-2.766,66.01-12.146,94.911-26.86 c-10.482-5.357-14.314-16.794-30.653-16.794C320,467.478,320,486.984,298.665,486.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M383.998,420.202c-21.333,0-21.333-19.506-42.665-19.506c-21.333,0-21.333,19.506-42.667,19.506 c-21.335,0-21.335-19.506-42.67-19.506c-21.333,0-21.333,19.506-42.665,19.506c-21.33,0-21.33-19.506-42.663-19.506 c-21.335,0-21.335,19.506-42.67,19.506s-21.335-19.506-42.67-19.506c-15.341,0-19.649,10.09-28.794,15.755 c5.732,7.118,11.826,13.932,18.275,20.392c2.889-1.234,6.279-2.013,10.518-2.013c21.335,0,21.335,19.504,42.67,19.504 s21.335-19.504,42.67-19.504c21.333,0,21.333,19.504,42.663,19.504c21.333,0,21.333-19.504,42.665-19.504 c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504s21.333,19.504,42.665,19.504 s21.333-19.504,42.665-19.504c4.244,0,7.634,0.779,10.525,2.015c6.45-6.461,12.544-13.275,18.276-20.393 c-9.146-5.664-13.454-15.755-28.8-15.755C405.33,400.696,405.33,420.202,383.998,420.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,0c-0.016,0-0.028,0-0.043,0H256L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M255.315,256H256c0-0.23,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "289.391,256 289.391,256 289.391,255.999 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "256,133.565 256,208.778 166.957,122.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "133.566,256 208.776,256 133.565,155.826 122.435,233.739  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,133.565C256,88.52,256,59.005,256,0h-0.043C114.592,0.024,0,114.629,0,256h133.566v-75.211 L208.776,256h46.54c0.228-0.228,0.456-0.456,0.685-0.685c0-17.247,0-32.636,0-46.537l-75.213-75.213H256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M129.515,33.391C89.476,56.19,56.19,89.476,33.391,129.515V256h66.783V100.176v-0.002H256 c0-21.063,0-41.129,0-66.783H129.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,224.519l-90.955-90.953h-31.48v0.002L255.998,256H256C256,256,256,234.293,256,224.519z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "333.913,133.565 434.087,133.565 384,183.652 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.87,
    y: 172.522,
    style: {
      fill: "#A2001D"
    },
    width: 22.261,
    height: 61.217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.87,
    y: 333.913,
    style: {
      fill: "#A2001D"
    },
    width: 22.261,
    height: 61.217
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M450.783,300.522c0-18.441-14.95-33.391-33.391-33.391c-8.554,0-16.352,3.22-22.261,8.509V256h11.13 v-22.261h-11.13v-11.13H372.87v11.13h-11.13V256h11.13v19.64c-5.909-5.289-13.707-8.509-22.261-8.509 c-18.441,0-33.391,14.95-33.391,33.391c0,9.887,4.301,18.767,11.13,24.882v19.64h111.304v-19.64 C446.482,319.289,450.783,310.409,450.783,300.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M417.391,289.391c-3.511,0-5.969,1.542-7.414,2.834l-14.847,13.291H372.87l-14.847-13.291 c-1.445-1.292-3.903-2.834-7.414-2.834c-6.137,0-11.13,4.993-11.13,11.13c0,4.323,2.331,7.054,3.72,8.299l7.411,6.636v7.326h66.783 v-7.326l7.411-6.636c1.389-1.244,3.72-3.976,3.72-8.299C428.522,294.384,423.529,289.391,417.391,289.391z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.79e9ddfa3bf6db1bf8cfc90b69b9649d.svg";
export { ForwardRef as ReactComponent };